import {EvkOption} from "@evomatik/evk-common";

export class EvkSeccionConfigModel {

    titulo: string;
    descripcion: string;
    orden: number;
    metadataForm: string;
    configuracionUI: any;
    origen: any;
    cardinalidad: any;
    requerido: boolean;
    nombre: string;
    generarFolio: boolean;
    datosAdicionales: any;
    idBandeja: string;
    roles?: string;
    formatos?: EvkOption[];
    metadataFormId: string;
    ui: string;
}
